import {Component, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'form-Invalid-modal',
    template: `
    <div class="modal-header">
      <h5 class="modal-title text-danger">{{title}}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onClose()" ></button>
    </div>
    <div class="modal-body">
      <p class="text-danger" [innerHTML]="message"></p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="onClose()">Close</button>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormInvalidComponent {
  public title = 'Missing or Invalid Data'
  public message = 'Please complete all the required fields and check the data for proper format.';
  constructor(private activeModal: NgbActiveModal) { }

  public onClose() {
    this.activeModal.dismiss();
  }
}
